import { render, staticRenderFns } from "./CabinetCash.vue?vue&type=template&id=5f8b3508&scoped=true&"
import script from "./CabinetCash.vue?vue&type=script&lang=js&"
export * from "./CabinetCash.vue?vue&type=script&lang=js&"
import style0 from "./CabinetCash.vue?vue&type=style&index=0&id=5f8b3508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8b3508",
  null
  
)

export default component.exports